import { ReadProjectScheduleContractorVisit } from "@/types/projectSchedule";
import { memo } from "react";
import { useTranslation } from "react-i18next";

interface ProjectSchedulesVisitTimeDetailsProps {
  visit?: ReadProjectScheduleContractorVisit;
}

const NO_BREAK_SPACE = "\u00A0";

const ProjectSchedulesVisitTimeDetailsComponent = ({
  visit,
}: ProjectSchedulesVisitTimeDetailsProps) => {
  const { t } = useTranslation();

  if (!visit) {
    return <div className="text-sm text-muted-foreground">{t("noData")}</div>;
  }

  return (
    <div className="grid grid-cols-2 gap-4 text-sm">
      <div className="flex">
        <span className="font-medium flex-shrink-0">
          {t("projectSchedules.fields.suggested_start_time")}:
        </span>
        <span className="ml-2 flex-1 min-w-[3rem]">
          {visit.suggested_start_time || NO_BREAK_SPACE}
        </span>
      </div>
      <div className="flex">
        <span className="font-medium flex-shrink-0">
          {t("projectSchedules.fields.suggested_end_time")}:
        </span>
        <span className="ml-2 flex-1 min-w-[3rem]">
          {visit.suggested_end_time || NO_BREAK_SPACE}
        </span>
      </div>
      <div className="flex">
        <span className="font-medium flex-shrink-0">
          {t("projectSchedules.fields.kam_planned_duration")}:
        </span>
        <span className="ml-2 flex-1 min-w-[3rem]">
          {visit.kam_planned_duration || NO_BREAK_SPACE}
        </span>
      </div>
      <div className="flex">
        <span className="font-medium flex-shrink-0">
          {t("projectSchedules.fields.pr_planned_duration")}:
        </span>
        <span className="ml-2 flex-1 min-w-[3rem]">
          {visit.pr_planned_duration || NO_BREAK_SPACE}
        </span>
      </div>
    </div>
  );
};

export const ProjectSchedulesVisitTimeDetails = memo(
  ProjectSchedulesVisitTimeDetailsComponent,
);
